<template>
  <div>
    <template v-if="type == 'coupon'">
      <div class="l-list-coupon__column__info--time">
        <div class="mb-5 c-tag c-tag--violet" :class="size == 'xl' ? ' c-tag--xl' :''">利用期限</div>
        <div v-if="!unlimited" :class="size == 'xl' ? '' :'date'">
          {{ availableFrom && formatDateForOrder(availableFrom) }}〜{{ availableTo && formatDateForOrder(availableTo) }}
        </div>
        <div v-else class="date">無期限</div>
      </div>
    </template>
    <template v-else-if="type == 'campaign'">
      <div class="c-info--time">
        <div v-if="!unlimited" class="date">
          <span v-if="isLotteryPossible" class="unread"></span>
           開催期間：{{ availableFrom && formatDateForOrder(availableFrom) }}〜{{ availableTo && formatDateForOrder(availableTo) }}
        </div>
      </div>
    </template>
    <template v-else>
      <div />
    </template>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Tenant } from "../../plugin/mixin.js";

export default Vue.extend({
  name: 'expirationDate',
  props: [ 'type', 'size','unlimited', 'availableFrom','availableTo','isEntered','isEnded'],
  mixins: [Tenant],
  components: {
  },
  async created() {
  },
  data() {
    return {
    }
  },
  computed: {
    isLotteryPossible: function() {
      const now = Date.now();
      if (this.availableFrom && this.availableFrom > now) {
        return false;
      }
      if (this.availableTo && this.availableTo < now) {
        return false;
      }
      if (this.isEntered) {
        return false;
      }
      if (this.isEnded) {
        return false;
      }
      return true;
    },
  }
})
</script>